import gql from 'graphql-tag';

export const LIST_OF_CALENDAR_ACTIVITIES = gql`
  query ListOfCalendarActivities($input: CalendarEventsInput!) {
    dealActivity {
      result: calendarActivities(input: $input) {
        error
        success
        list {
          id
          type
          title
          description
          occurredAt
          parentId
          parentType
        }
      }
    }
  }
`;
